import type { JobDetails } from '@/api/fe-api/domain/entities/capacity-evaluation';
import type { Site } from '@/api/fe-api/domain/entities/site';
import { GetAggregatedResults } from '@/api/fe-api/view/queries/capacity-evalution/get-aggregated-results';

import { capitalizeFirstLetter } from '../../utils';

import { SectionThroughputCharts } from './section-throughput-charts';
import { SectionThroughputTable } from './section-throughput-table';

export type CapacityTestResultsAggregatedProps = {
  capacityTest: JobDetails;
  asset: Site;
  level: string;
};
export function CapacityTestResultsAggregated({
  capacityTest,
  asset,
  level,
}: CapacityTestResultsAggregatedProps) {
  const { data } = GetAggregatedResults.useQuery({
    id: capacityTest.id,
    level,
    siteFullFrontendId: asset.fullFrontendId,
  });

  if (!data?.isOk()) {
    return null;
  }

  return (
    <>
      <div className="space-y-4 rounded border border-zinc-400/20 p-6">
        <div className="flex">
          <h4 className="text-lg">Energy Throughput</h4>
        </div>
        <SectionThroughputCharts
          labels={[
            capitalizeFirstLetter(level),
            capitalizeFirstLetter(level + 's'),
          ]}
          results={data.value}
        />
      </div>
      <div className="rounded border border-zinc-400/20 p-6">
        <SectionThroughputTable
          labels={[
            capitalizeFirstLetter(level),
            capitalizeFirstLetter(level + 's'),
          ]}
          capacityTest={capacityTest}
          results={data.value}
        />
      </div>
    </>
  );
}
